export * from './power-resource-needed.component';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/power-resource-needed.component/index.ts